import { createSlice } from '@reduxjs/toolkit';
import type { OrganizationState } from './organization-interface';
import { setSelectedOrganizationFun } from './organization-utils';

export const organizationStateSliceName = 'organizationStateSlice';

export const organizationStateInitialValue: OrganizationState = {
  selectedOrganization: null,
};

export const organizationStateSlice = createSlice({
  name: organizationStateSliceName,
  initialState: organizationStateInitialValue,
  reducers: {
    setSelectedOrganization: setSelectedOrganizationFun,
  },
});

export const { setSelectedOrganization } = organizationStateSlice.actions;
export const organizationStateSliceReducerKey = 'organization';
export default organizationStateSlice.reducer;
